import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { auth } from "../firebaseConfig";
import { verifyPasswordResetCode, confirmPasswordReset } from "firebase/auth";

const ResetPassword = () => {
  const navigate = useNavigate();
  const [checking, setChecking] = useState(true);
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [done, setDone] = useState(false);
  const [loading, setLoading] = useState(false);

  // Extrair parâmetros da URL
  const urlParams = new URLSearchParams(window.location.search);
  const oobCode = urlParams.get("oobCode");

  useEffect(() => {
    if (!oobCode) {
      setError("Link inválido. Falta o código de redefinição.");
      setChecking(false);
      return;
    }

    // Validar o código de redefinição
    verifyPasswordResetCode(auth, oobCode)
      .then((email) => {
        setEmail(email);
      })
      .catch((err) => {
        console.error("Erro ao verificar código:", err);
        setError("Link expirado ou inválido. Solicite um novo link de recuperação.");
      })
      .finally(() => {
        setChecking(false);
      });
  }, [oobCode]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    // Validações
    if (password.length < 6) {
      setError("A senha deve ter pelo menos 6 caracteres.");
      setLoading(false);
      return;
    }

    if (password !== confirmPassword) {
      setError("As senhas não conferem.");
      setLoading(false);
      return;
    }

    try {
      await confirmPasswordReset(auth, oobCode, password);
      setDone(true);
      
      // Redirecionar para login após 2 segundos
      setTimeout(() => {
        navigate("/login");
      }, 2000);
    } catch (err) {
      console.error("Erro ao redefinir senha:", err);
      setError("Não foi possível redefinir a senha. O link pode ter expirado. Solicite um novo link.");
    } finally {
      setLoading(false);
    }
  };

  if (checking) {
    return (
      <div style={{ 
        minHeight: "100vh", 
        background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
        display: "flex", 
        alignItems: "center", 
        justifyContent: "center", 
        padding: "20px" 
      }}>
        <div style={{ 
          backgroundColor: "white", 
          borderRadius: "20px", 
          boxShadow: "0 20px 40px rgba(0,0,0,0.1)", 
          padding: "40px", 
          maxWidth: "400px", 
          width: "100%",
          textAlign: "center"
        }}>
          <div style={{
            width: "60px",
            height: "60px",
            border: "4px solid #f3f3f3",
            borderTop: "4px solid #667eea",
            borderRadius: "50%",
            animation: "spin 1s linear infinite",
            margin: "0 auto 20px"
          }}></div>
          <h1 style={{ 
            fontSize: "24px", 
            fontWeight: "bold", 
            color: "#2d3748", 
            marginBottom: "10px" 
          }}>
            Validando Link
          </h1>
          <p style={{ color: "#718096", fontSize: "16px" }}>
            Aguarde enquanto validamos seu link de recuperação...
          </p>
        </div>
        
        <style>{`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}</style>
      </div>
    );
  }

  if (done) {
    return (
      <div style={{ 
        minHeight: "100vh", 
        background: "linear-gradient(135deg, #4ade80 0%, #22c55e 100%)",
        display: "flex", 
        alignItems: "center", 
        justifyContent: "center", 
        padding: "20px" 
      }}>
        <div style={{ 
          backgroundColor: "white", 
          borderRadius: "20px", 
          boxShadow: "0 20px 40px rgba(0,0,0,0.1)", 
          padding: "40px", 
          maxWidth: "400px", 
          width: "100%",
          textAlign: "center"
        }}>
          <div style={{ 
            fontSize: "80px", 
            color: "#22c55e", 
            marginBottom: "20px" 
          }}>
            ✓
          </div>
          <h1 style={{ 
            fontSize: "24px", 
            fontWeight: "bold", 
            color: "#166534", 
            marginBottom: "10px" 
          }}>
            Senha Alterada com Sucesso!
          </h1>
          <p style={{ color: "#16a34a", fontSize: "16px", marginBottom: "20px" }}>
            Sua senha foi redefinida com sucesso.
          </p>
          <p style={{ color: "#6b7280", fontSize: "14px" }}>
            Redirecionando para a página de login...
          </p>
        </div>
      </div>
    );
  }

  return (
    <div style={{ 
      minHeight: "100vh", 
      background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
      display: "flex", 
      alignItems: "center", 
      justifyContent: "center", 
      padding: "20px" 
    }}>
      <div style={{ 
        backgroundColor: "white", 
        borderRadius: "20px", 
        boxShadow: "0 20px 40px rgba(0,0,0,0.1)", 
        padding: "40px", 
        maxWidth: "450px", 
        width: "100%" 
      }}>
        <div style={{ textAlign: "center", marginBottom: "30px" }}>
          <div style={{
            width: "60px",
            height: "60px",
            backgroundColor: "#667eea",
            borderRadius: "50%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            margin: "0 auto 20px"
          }}>
            <span style={{ fontSize: "24px", color: "white" }}>🔐</span>
          </div>
          <h1 style={{ 
            fontSize: "28px", 
            fontWeight: "bold", 
            color: "#2d3748", 
            marginBottom: "8px" 
          }}>
            Redefinir Senha
          </h1>
          <p style={{ color: "#718096", fontSize: "16px" }}>
            Digite sua nova senha abaixo
          </p>
        </div>

        {email && (
          <div style={{ 
            backgroundColor: "#eff6ff", 
            border: "1px solid #bfdbfe", 
            borderRadius: "12px", 
            padding: "16px", 
            marginBottom: "24px" 
          }}>
            <p style={{ fontSize: "14px", color: "#1e40af", margin: 0 }}>
              <strong>Conta:</strong> {email}
            </p>
          </div>
        )}

        {error && (
          <div style={{ 
            backgroundColor: "#fef2f2", 
            border: "1px solid #fecaca", 
            borderRadius: "12px", 
            padding: "16px", 
            marginBottom: "24px" 
          }}>
            <p style={{ fontSize: "14px", color: "#dc2626", margin: 0 }}>
              {error}
            </p>
          </div>
        )}

        <form onSubmit={handleSubmit} style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
          <div>
            <label style={{ 
              display: "block", 
              fontSize: "14px", 
              fontWeight: "600", 
              color: "#374151", 
              marginBottom: "8px" 
            }}>
              Nova senha
            </label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              minLength={6}
              style={{
                width: "100%",
                padding: "16px",
                border: "2px solid #e5e7eb",
                borderRadius: "12px",
                outline: "none",
                fontSize: "16px",
                transition: "all 0.2s",
                boxSizing: "border-box"
              }}
              onFocus={(e) => {
                e.target.style.borderColor = "#667eea";
                e.target.style.boxShadow = "0 0 0 3px rgba(102, 126, 234, 0.1)";
              }}
              onBlur={(e) => {
                e.target.style.borderColor = "#e5e7eb";
                e.target.style.boxShadow = "none";
              }}
              placeholder="Digite sua nova senha"
              disabled={loading}
            />
          </div>
          
          <div>
            <label style={{ 
              display: "block", 
              fontSize: "14px", 
              fontWeight: "600", 
              color: "#374151", 
              marginBottom: "8px" 
            }}>
              Confirmar nova senha
            </label>
            <input
              type="password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
              minLength={6}
              style={{
                width: "100%",
                padding: "16px",
                border: "2px solid #e5e7eb",
                borderRadius: "12px",
                outline: "none",
                fontSize: "16px",
                transition: "all 0.2s",
                boxSizing: "border-box"
              }}
              onFocus={(e) => {
                e.target.style.borderColor = "#667eea";
                e.target.style.boxShadow = "0 0 0 3px rgba(102, 126, 234, 0.1)";
              }}
              onBlur={(e) => {
                e.target.style.borderColor = "#e5e7eb";
                e.target.style.boxShadow = "none";
              }}
              placeholder="Confirme sua nova senha"
              disabled={loading}
            />
          </div>
          
          <button
            type="submit"
            disabled={loading}
            style={{
              width: "100%",
              backgroundColor: loading ? "#9ca3af" : "#667eea",
              color: "white",
              padding: "16px",
              borderRadius: "12px",
              border: "none",
              fontSize: "16px",
              fontWeight: "600",
              cursor: loading ? "not-allowed" : "pointer",
              transition: "all 0.2s",
              marginTop: "10px"
            }}
            onMouseOver={(e) => {
              if (!loading) {
                e.target.style.backgroundColor = "#5a67d8";
                e.target.style.transform = "translateY(-1px)";
                e.target.style.boxShadow = "0 4px 12px rgba(102, 126, 234, 0.4)";
              }
            }}
            onMouseOut={(e) => {
              if (!loading) {
                e.target.style.backgroundColor = "#667eea";
                e.target.style.transform = "translateY(0)";
                e.target.style.boxShadow = "none";
              }
            }}
          >
            {loading ? "Redefinindo..." : "Redefinir Senha"}
          </button>

          <div style={{ textAlign: "center", marginTop: "20px" }}>
            <button
              type="button"
              onClick={() => navigate("/login")}
              style={{
                color: "#667eea",
                textDecoration: "underline",
                fontSize: "14px",
                border: "none",
                background: "none",
                cursor: "pointer",
                fontWeight: "500"
              }}
              onMouseOver={(e) => {
                e.target.style.color = "#5a67d8";
              }}
              onMouseOut={(e) => {
                e.target.style.color = "#667eea";
              }}
            >
              Lembrou da senha? Fazer login
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ResetPassword;